<script setup>
import {inject} from "vue";

const matchDetail = inject("matchDetail");
const joinData = inject('joinData')

const emit = defineEmits(['handleCreateTeam','handleJoinTeam'])
const handleCreateTeam = () => {
  emit('handleCreateTeam')
}
const handleJoinTeam = (data) => {
  emit('handleJoinTeam',data)
}

const img = require('@/assets/web/tournaments/car.png')

const dataFilter = (data) => {
  let returnData = data.filter(item => item.leader!= 1)
  if(returnData.length > 7){
    returnData = returnData.slice(0,7)
  }else {
    // 补充到7个
    let length = 7 - returnData.length
    for(let i = 0; i < length; i++){
      returnData.push({memberPhoto: img})
    }
  }
  return returnData
}
</script>

<template>
  <div class="teams">
     <div class="title">
       <p>All teams({{matchDetail.teams.length}})</p>
       <el-button type="primary" class="btn" @click="handleCreateTeam" v-if="!joinData.isJoin">Create a team</el-button>
    </div>

    <div class="team-list">
      <div class="item" v-for="item in matchDetail.teams" :key="item">
        <div class="content">
          <p class="name">{{item.name}}</p>
          <div class="flex-b-c">
            <div class="staff">
              <div class="captain" >
                <img alt="" :src="item.teamMemberVoList.filter(item => item.leader == 1)[0].memberPhoto" />
              </div>
              <div class="player">
                <img v-for="v in dataFilter(item.teamMemberVoList)" alt="" :src="v.memberPhoto" />
              </div>
            </div>
            <el-button type="primary" class="btn" @click="handleJoinTeam(item)" v-if="!joinData.isJoin">Join</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.btn {
  width: 167px;
  height: 44px;
  background: #FFB20E;
  border-radius: 6PX;
  font-size: 14PX;
  margin: 30PX 0;
  line-height: 28PX;
  text-align: center;
  cursor: pointer;
  border: none;
  color: #ffffff;
}
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  font-size: 24px;
  line-height: 44px;
  p{
    margin: 30px 0;
  }
}

.team-list{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  width: 1650px;

  .item{
    width: calc(50% - 12px);
    height: 133px;
    background: #262F3F;
    position: relative;
    border-radius: 17px;
    overflow: hidden;
    margin-bottom: 24px;
    color: #ffffff;
    padding: 10px 24px;

    &:before{
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 58.55%;
      background: linear-gradient( 279deg, #262F3F 0%, #2C2B27 100%);
    }

    .flex-b-c{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .content{
      position: relative;
      z-index: 2;
      .name{
        font-size: 18px;
      }

      img{
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 30px;
      }

      .btn{
        width: 83px;
        height: 40px;
      }

      .staff{
        margin: 30PX 0;
      }

      .staff,.player{
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .captain{
        padding-right: 30px;
        position: relative;
        margin-right: 30px;
        img{
          margin-right: 0;
        }

        &:after{
          content: '';
          display: block;
          position: absolute;
          right: 0;
          top: 0;
          height: 44px;
          width: 1px;
          background: #394356;
        }
      }
    }
  }

  & > .item:nth-child(2n){
    margin-left: 24px;
  }
}
</style>
